/**
 * Вычисляет расстояние между двумя географическими точками используя формулу Haversine
 * @param coord1 - Первая точка [longitude, latitude]
 * @param coord2 - Вторая точка [longitude, latitude]
 * @returns Расстояние в метрах
 */
export function calculateDistance(
  coord1: [number, number],
  coord2: [number, number]
): number {
  const R = 6371000; // Радиус Земли в метрах

  const lat1 = (coord1[1] * Math.PI) / 180;
  const lat2 = (coord2[1] * Math.PI) / 180;
  const deltaLat = ((coord2[1] - coord1[1]) * Math.PI) / 180;
  const deltaLng = ((coord2[0] - coord1[0]) * Math.PI) / 180;

  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // расстояние в метрах
}

/**
 * Склоняет слово "метр" в зависимости от числа
 * @param number - Число метров
 * @returns Правильная форма слова "метр"
 */
function pluralizeMeters(number: number): string {
  const lastDigit = number % 10;
  const lastTwoDigits = number % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return "метров";
  }

  if (lastDigit === 1) {
    return "метр";
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return "метра";
  }

  return "метров";
}

/**
 * Форматирует расстояние для отображения пользователю
 * @param distance - Расстояние в метрах
 * @returns Отформатированная строка с расстоянием
 */
export function formatDistance(distance: number): string {
  if (distance < 1000) {
    const rounded = Math.round(distance);
    return `${rounded} ${pluralizeMeters(rounded)}`;
  }
  return `${(distance / 1000).toFixed(1)} км`;
}
